export default __webpack_public_path__ + "static/1-729b9fae76d4522832393a22154cb4da.jpeg";